import { createFileRoute } from '@tanstack/react-router'
import SignupPage from '#/pages/SignupPage'

export const Route = createFileRoute('/_auth/signup')({
  component: SignupPage,
  head: () => ({
    meta: [
      { title: "Create Account — Wa'allamah" },
      {
        name: 'description',
        content:
          "Create your student account at Wa'allamah to begin your personalized Quran and Islamic studies journey.",
      },
    ],
  }),
})
